import React, { useContext } from "react";

import PermissionWrapper from "../../../../../../../global/PermissionWrapper";
import { StaticBarStateContext } from "../../context/StaticBarContext";
import CaseStatus from "../fields/CaseStatus";
import LegalStatus from "../fields/LegalStatus";
import MedicalStatus from "../fields/MedicalStatus";
import ProvidersInNetwork from "../fields/ProvidersInNetwork";
import ProvidersOutNetwork from "../fields/ProvidersOutNetwork";
import Column from "../ui/Column";

const StatusSummary = () => {
  const state = useContext(StaticBarStateContext);
  return (
    <Column>
      {state.data?.status && (
        <PermissionWrapper permission={state.data?.status?.can_view}>
          <MedicalStatus
            fieldName={state.data?.status?.fieldName}
            value={state.data?.status?.value}
            flag={state.data?.status?.flag_state}
            clock={state.data?.status?.clock_state}
            updatedAt={state?.data?.statusUpdatedAt?.value}
            updatedBy={state?.data?.statusUpdatedBy?.value}
          />
        </PermissionWrapper>
      )}
      {state.data?.legalStatus && (
        <PermissionWrapper permission={state.data?.legalStatus?.can_view}>
          <LegalStatus
            fieldName={state.data?.legalStatus?.fieldName}
            value={state.data?.legalStatus?.value}
            flag={state.data?.legalStatus?.flag_state}
            clock={state.data?.legalStatus?.clock_state}
            updatedAt={state?.data?.legalStatusUpdatedAt?.value}
            updatedBy={state?.data?.legalStatusUpdatedBy?.value}
          />
        </PermissionWrapper>
      )}
      {state.data?.overallStatus && (
        <PermissionWrapper permission={state.data?.overallStatus?.can_view}>
          <CaseStatus
            fieldName={state.data?.overallStatus?.fieldName}
            value={state.data?.overallStatus?.value}
            flag={state.data?.overallStatus?.flag_state}
            clock={state.data?.overallStatus?.clock_state}
            updatedAt={state?.data?.overallStatusUpdatedAt?.value}
            updatedBy={state?.data?.overallStatusUpdatedBy?.value}
          />
        </PermissionWrapper>
      )}
      <div className="flex">
        {state.data?.allInNetworkAppointmentsCount && (
          <PermissionWrapper permission={state.data?.allInNetworkAppointmentsCount?.can_view}>
            <ProvidersInNetwork
              fieldName={state.data?.allInNetworkAppointmentsCount?.fieldName}
              value={state.data?.allInNetworkAppointmentsCount?.value}
              flag={state.data?.allInNetworkAppointmentsCount?.flag_state}
              clock={state.data?.allInNetworkAppointmentsCount?.clock_state}
              title={state.data?.allInNetworkProvidersCount?.value}
            />
          </PermissionWrapper>
        )}
        {state.data?.allOutNetworkAppointmentsCount && (
          <PermissionWrapper permission={state.data?.allOutNetworkAppointmentsCount?.can_view}>
            <ProvidersOutNetwork
              fieldName={state.data?.allOutNetworkAppointmentsCount?.fieldName}
              value={state.data?.allOutNetworkAppointmentsCount?.value}
              flag={state.data?.allOutNetworkAppointmentsCount?.flag_state}
              clock={state.data?.allOutNetworkAppointmentsCount?.clock_state}
              title={state.data?.allOutOfNetworkProvidersCount?.value}
            />
          </PermissionWrapper>
        )}
      </div>
    </Column>
  );
};

export default StatusSummary;
